<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5609 6.5V3.5L16.2805 2L19 3.5V6.5L16.2805 8L13.5609 6.5ZM13.5609 6.5L6.43905 8.5M6.43905 8.5L3.71953 7L1 8.5V11.5L3.71953 13L6.43905 11.5M6.43905 8.5V11.5M6.43905 11.5L13.5609 13.5M13.5609 13.5V16.5L16.2805 18L19 16.5V13.5L16.2805 12L13.5609 13.5Z" stroke="#006EFF" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: "IconShare",
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 20 },
    color: { type: String, default: "#D3D4DE" }
  }
}
</script>